package com.heelion.farmafreelance.ui

import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue

/**
 * Intensità del lampeggio (0 = spento, 1 = massimo) per attirare l'attenzione su campanella e
 * proposte insieme al suono delle notifiche. Con [attivo] false resta 0.
 */
@Composable
fun rememberLampeggio(attivo: Boolean): Float {
    if (!attivo) return 0f
    val transizione = rememberInfiniteTransition(label = "lampeggio")
    val valore by transizione.animateFloat(
        initialValue = 0f,
        targetValue = 1f,
        animationSpec = infiniteRepeatable(tween(durationMillis = 450), RepeatMode.Reverse),
        label = "lampeggio"
    )
    return valore
}
